import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Stack } from '@mui/material';
import { Inputs } from 'components';
import yup from 'config/yup.custom';
import { NotifyService, hasPermission } from 'helpers';
import { memo, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { createNoteApi, getListNotesApi } from 'services';

interface Props {
  sitter_id?: string;
}

interface IFormInputs {
  note: string;
}

const defaultValues: Partial<IFormInputs> = {
  note: '',
};

const schema = yup.object({
  note: yup.string().required('Note is required'),
});

const Notes = memo(({ sitter_id }: Props) => {
  const [disabled, setDisabled] = useState(true);
  const form = useForm<IFormInputs>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: defaultValues,
  });

  const { reset, handleSubmit, watch } = form;

  const fetchData = async () => {
    await getListNotesApi({ sitter_id: sitter_id })
      .then(({ data }) => {
        reset({
          note: data.data.note,
        });
      })
      .catch((e) => NotifyService.error(e));
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === 'note') {
        if (value.note !== defaultValues.note) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = async (value: IFormInputs) => {
    await createNoteApi({ sitter_id: sitter_id, note: value.note })
      .then(() => {
        NotifyService.success('Success');
        setDisabled(true);
      })
      .catch((e) => NotifyService.error(e));
  };

  return (
    <Stack spacing="8px">
      <Box onSubmit={handleSubmit(onSubmit)} component="form">
        <Stack direction="row" spacing="8px" justifyContent="flex-end">
          {hasPermission(['superadmin', 'staff']) && (
            <Button
              disabled={disabled}
              color="secondary"
              variant="contained"
              type="submit"
              sx={{
                marginBottom: '8px',
                height: '32px',
              }}
            >
              Save
            </Button>
          )}
        </Stack>
        <Inputs form={form} name="note" rows={10} placeholder="Enter note" />
      </Box>
    </Stack>
  );
});

export default Notes;
